import { useState } from "react";
import { Icon } from "@sellar-io/components";
import { useShallow } from "zustand/react/shallow";
import { defaultLondonLocation } from "../../../components/map/SellarMap.shared";
import { useSellarMapStore } from "../../../components/map/SellarMapStore";
import { NavigationBarMenu } from "../../../components/navigation/NavigationBar";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { BuyerRelationships } from "./BuyerRelationships";
import { DraftBasketDrawer } from "../../discovery/v2/distribution/DraftBasketDrawer";
import { useDraftDbsBaskets } from "../../discovery/v2/distribution/useDraftDbsBaskets";
import { QuantityIndicator } from "../../../components/quantityIndicator/QuantityIndicator";
import { useCanShowDeliveredBySellarOptionV2 } from "../../discovery/v2/lib/useCanShowDeliveredBySellarOptionV2";
import { useRemoteFeatureFlags } from "../../../hooks/useRemoteFeatureFlags";

export function BuyerConnectedSupplierList() {
  const { business } = useSellarCurrentBusiness();
  const [draftBasketDrawerActive, setDraftBasketDrawerActive] = useState(false);
  const { totalItemCount } = useDraftDbsBaskets();
  const canShowDeliveredBySellar = useCanShowDeliveredBySellarOptionV2();
  const sdConsolidatedCheckoutEnabled = useRemoteFeatureFlags().isActive(
    "sdConsolidatedCheckout",
  );

  if (!business?.Retailer) throw new Error("Cannot find buyer");

  const { add, location } = useSellarMapStore(
    useShallow((state) => ({
      add: state.add,
      location: state.location,
    })),
  );

  const businessLocation = business.Location ?? null;
  if (!location) add(businessLocation ?? defaultLondonLocation);

  return (
    <>
      <NavigationBarMenu
        title={"Suppliers"}
        borderBottom={false}
        rightComponent={
          <button
            type="button"
            aria-label="Open basket"
            className="flex min-h-11 min-w-11 cursor-pointer items-center justify-end gap-1"
            onClick={() => setDraftBasketDrawerActive(true)}
          >
            <Icon icon="CART_OUTLINE" size={1} />
            {canShowDeliveredBySellar && totalItemCount > 0 && (
              <QuantityIndicator
                quantity={totalItemCount}
                className="bg-[#A34FD2]"
              />
            )}
          </button>
        }
      />

      <div className="pb-8">
        <BuyerRelationships
          onOpenDraftBasketDrawer={() => setDraftBasketDrawerActive(true)}
        />
      </div>
      <DraftBasketDrawer
        active={draftBasketDrawerActive}
        setActive={setDraftBasketDrawerActive}
        showDeliveredBySellarFeatures={
          sdConsolidatedCheckoutEnabled && canShowDeliveredBySellar
        }
      />
    </>
  );
}
